export const environment = {
  production: true,
  environment: "alkqaaws",
  apiUrl: "https://api-copilotfleetportal-qa.alk.com",
  ssoUrl: "https://authws-qa.alk.com/api",
  fleetViewUrl: "https://copilotroutereporter-qa.alk.com/",
  fleetApiUrl: "https://fleets-qa.trimblemaps.com/",
  httpRequestTimeoutSeconds: 120,
  trackJsEnvironment: "cfl-alkqaaws",
  applicationName: "CoPilot FleetPortal",
  hubspotPortalId: "4239221",
  hubspotFormId: "4a95f3d9-5b44-4704-8a75-2676b930f6fa",
  tidUrl: "https://stage.id.trimblecloud.com/oauth",
  tidAppName: "Solera_Fleet_Portal--dev-qa",
  tidClientId: "f524fd20-30b7-4034-a792-ecaac625ee3e",
  tidClientSecret: "9f7fbcf0c33346aaad198047ab001cbc",
};
